import { h } from 'vue'
import SvgIcon from '../index.vue'

export const createSvgIcon = ({ dir, name } = {}) => {
  return (attr) => h(SvgIcon, { dir, name, ...attr })
}
